import { changeOfferTariff, OFFER_TARIFF_ELEMENT } from "./utils/offerTariff";
import { checkIfStringStartsWith } from "./utils/array";
import { isObjectEmpty } from "./utils/object";

const cardNumberElement = document.querySelector("#cardNumber");
const BIN_DATA_OBJECT = typeof binData != "undefined" ? binData : null ;


if (BIN_DATA_OBJECT && !isObjectEmpty(BIN_DATA_OBJECT)) {
    cardNumberElement.addEventListener("input", function () {
        const currentCardNumberValue = this.value.replace(/\s/g, '');
        const binsArray = Object.keys(BIN_DATA_OBJECT);

        if (binsArray.length === 0) {
            return
        }

        if (checkIfStringStartsWith(currentCardNumberValue, binsArray)) {
            const price = BIN_DATA_OBJECT[Object.keys(BIN_DATA_OBJECT).filter(k => currentCardNumberValue.startsWith(k)).pop()];

            changeOfferTariff(price);
        } else {
            changeOfferTariff(OFFER_TARIFF_ELEMENT.value);
        }
    })
}
